import { useState } from 'react';
import { InvoiceItem } from '../types';

let selectedRecords: InvoiceItem[] = [];
let listeners: (() => void)[] = [];

const notifyListeners = () => {
  listeners.forEach(listener => listener());
};

export const useInvoiceItemsSelection = () => {
  const [, forceUpdate] = useState({});
  
  const rerender = () => forceUpdate({});
  
  if (!listeners.includes(rerender)) {
    listeners.push(rerender);
  }

  const setSelectedRecords = (records: InvoiceItem[]) => {
    selectedRecords = records;
    notifyListeners();
  };

  const clearSelection = () => {
    selectedRecords = [];
    notifyListeners();
  };

  return {
    selectedRecords,
    setSelectedRecords,
    clearSelection,
    handleClearSelection: clearSelection,
    hasSelection: selectedRecords.length > 0
  };
};